import { render, staticRenderFns } from "./servicos-ouvidoria.vue?vue&type=template&id=918ffc3c&scoped=true&"
import script from "./servicos-ouvidoria.vue?vue&type=script&lang=js&"
export * from "./servicos-ouvidoria.vue?vue&type=script&lang=js&"
import style0 from "./servicos-ouvidoria.vue?vue&type=style&index=0&id=918ffc3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918ffc3c",
  null
  
)

export default component.exports